import { ConnectedGreeks } from 'components/shared/Sensitivity/ConnectedGreeks';
import { useQuoteWorkspaceContext } from 'contexts/quote-workspace.context';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';

export function ProductSummaryGreeksField() {
  const workspace = useQuoteWorkspaceContext();
  const tabId = useAssertedActiveTabId();

  return <ConnectedGreeks formId={tabId} workspace={workspace} />;
}
